"use client";

import { useState } from "react";
import { Typography, Card, Form, Input, Button, Alert, Result } from "antd";
import { SiteHeader, SiteFooter } from "@/widgets/site-layout";
import { api } from "@/shared/api";

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

interface ContactFormValues {
  name: string;
  email: string;
  company?: string;
  message: string;
}

export default function ContactPage() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [form] = Form.useForm<ContactFormValues>();

  const handleSubmit = async (values: ContactFormValues) => {
    setLoading(true);
    setError(null);
    try {
      await api.contact.submit(values);
      setSuccess(true);
      form.resetFields();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Ошибка отправки");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SiteHeader />
      <main style={{ padding: "64px 24px", background: "#f5f5f5", flex: 1 }}>
        <div style={{ maxWidth: 560, margin: "0 auto" }}>
          <Title level={1} style={{ textAlign: "center" }}>Контакты</Title>
          <Paragraph type="secondary" style={{ textAlign: "center", marginTop: 16 }}>
            Расскажите о вашем проекте — мы свяжемся с вами
          </Paragraph>

          {success ? (
            <Card style={{ marginTop: 32 }}>
              <Result
                status="success"
                title="Спасибо!"
                subTitle="Мы получили ваше сообщение и скоро ответим."
              />
            </Card>
          ) : (
            <Card style={{ marginTop: 32 }}>
              <Form
                form={form}
                layout="vertical"
                onFinish={(values) => void handleSubmit(values)}
              >
                <Form.Item
                  name="name"
                  label="Имя"
                  rules={[{ required: true, message: "Введите имя" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="Эл. почта"
                  rules={[
                    { required: true, message: "Введите адрес эл. почты" },
                    { type: "email", message: "Некорректный адрес эл. почты" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item name="company" label="Компания">
                  <Input />
                </Form.Item>
                <Form.Item
                  name="message"
                  label="Сообщение"
                  rules={[{ required: true, message: "Введите сообщение" }]}
                >
                  <TextArea rows={5} />
                </Form.Item>
                {error && (
                  <Alert type="error" message={error} style={{ marginBottom: 16 }} />
                )}
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading} block>
                    Отправить
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          )}
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
